import { createSelector } from 'reselect';
import { isDomainDE } from '../constants/browser';
import { languageSelector } from './translations';

const stateSelector = state => state.ui;

export const isTypeformFeedbackSelector = createSelector(
  stateSelector,
  state => state.feedback.typeformFeedback
);

export const isFormalCommunicationSelector = createSelector(
  stateSelector,
  state => state.isFormalCommunication
);

export const hasAccountAccessInterestSelector = createSelector(
  languageSelector,
  stateSelector,
  (lang, state) =>
    isDomainDE() && lang === 'de_DE' && state.payment.accountAccessInterest
);
